export default "__VITE_ASSET__DrjHMvCV__"